module.exports = __webpack_public_path__ + "static/media/06_hero_mobile.278278af.jpg";